module.exports = __webpack_public_path__ + "img/menu-5.111b3783.png";